<app-apps-banner></app-apps-banner>

<section class="mt-5 container-vessel-tracker">
  <div class="container">
    <div class="row pb-80">
      <div class="col-lg-8 pe-md-4 pe-xl-5 border-right sm-border-none">
        <!-- <div class="d-flex align-items-center border-bottom pb-3">
        <img src="../assets/images/icons/container-specification.png" class="card-img-top img-fluid app-img mr-4" alt="Container Specification">
        <div>
          <p class="back-link mb-0">
            <i class="fa fa-angle-left pe-1" aria-hidden="true"></i>
            Back to all apps
          </p>
          <h2>Container Specification</h2>
        </div>
      </div> -->

      <div class="border-bottom pb-3 d-md-none d-block">
        <!-- <p class="back-link">
        <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
      </p> -->

      <a class="back-link linked" routerLink="/apps">
        <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
      </a>

      <div class="d-flex">
        <img src="../assets/images/icons/container-vessel-tracker.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
        <h2>Container Vessel Tracker</h2>
      </div>
    </div>

    <div class="d-md-flex align-items-md-center border-bottom pb-3 d-none d-md-flex">
      <img src="../assets/images/icons/container-vessel-tracker.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
      <div>
        <!-- <p class="back-link mb-0">
        <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
      </p> -->
      <a class="back-link linked" routerLink="/apps">
        <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
      </a>
      <h2>Container Vessel Tracker</h2>
    </div>
  </div>

  <div class="row border-bottom mb-3">
    <div class="col-lg-12 col-md-12">
      <form class="apps-form-input">
        <div class="form-group d-md-flex justify-content-start align-items-md-center mb-0">
          <label for="exampleFormControlSelect1" class="text-white" style="padding-left: 17px">Enter Vessel</label>
          <fieldset class="row">
            <div class="form-group col-sm-8">
              <input id="typeahead-prevent-manual-entry" [ngModelOptions]="{standalone: true}" type="text" class="form-control me-2" [(ngModel)]="conainerVesselname" placeholder="Enter vessel name" [ngbTypeahead]="search" [inputFormatter]="formatter" [resultFormatter]="formatter"
                [editable]='false' />
                <!-- <hr>
                <pre>Model: {{ model | json }}</pre> -->
              </div>
              <div class="col-sm-4">
                <button type="button" class="btn btn-sm btn-primary btn-details " style="margin-left: 10px;" (click)="onSubmit()">Submit</button>
              </div>
            </fieldset>
          </div>
        </form>
      </div>
    </div>
    <div class="cl-sm-12">
      <div class="top-image" [innerHTML]="iframeSrc | safehtml: 'html'"></div>
    </div>
    <div class="bg-gray p-3">
      <table class="table table-striped table-bordered table-responsive-sm mb-0">
        <thead class="table-dark">
          <tr>
            <th scope="col">Name</th>
            <th scope="col">IMO</th>
            <th scope="col">Country</th>
            <th scope="col">Year Built</th>
            <th scope="col">Vessel Type</th>
          </tr>
        </thead>
        <tbody>
          @for (item of conainerVesselTDetails; track item) {
            <tr>
              <th scope="row">{{item.cName}}</th>
              <td>{{item.iImo}}</td>
              <td>{{item.cCountry}}</td>
              <td>{{item.iYearbuilt}}</td>
              <td>{{item.cVesseltype}}</td>
            </tr>
          }
        </tbody>
      </table>


    </div>
  </div>

  <div class="col-lg-4 ps-md-4 ps-xl-5 pe-lg-0">
    <app-other-apps [menu]="'ContainerVessel'"></app-other-apps>
  </div>
</div>

</div>
</section>

<app-sat></app-sat>

<router-outlet></router-outlet>